import { render, staticRenderFns } from "./onlineDetails.vue?vue&type=template&id=dd6c92c6&scoped=true&"
import script from "./onlineDetails.vue?vue&type=script&lang=js&"
export * from "./onlineDetails.vue?vue&type=script&lang=js&"
import style0 from "./onlineDetails.vue?vue&type=style&index=0&id=dd6c92c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd6c92c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dd6c92c6')) {
      api.createRecord('dd6c92c6', component.options)
    } else {
      api.reload('dd6c92c6', component.options)
    }
    module.hot.accept("./onlineDetails.vue?vue&type=template&id=dd6c92c6&scoped=true&", function () {
      api.rerender('dd6c92c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataPirate/onlineDetails.vue"
export default component.exports